/* eslint-disable @typescript-eslint/no-unused-vars */

import { Modal, Select, Spin } from "antd";
import Styles from "../css/payWithQuickbucks.module.scss";
import { formatAmount } from "utils/currency";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Cancel from "../../../../assets/cancel.svg";
import Back from "../../../../assets/back-icon.svg";
import { useAppDispatch } from "customHooks/useAppDispatch";
import { useAppSelector } from "customHooks/useAppSelector";
import LoadingCard from "components/shared/LoadingCard/LoadingCard";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import Button from "components/shared/Button/Button";
import { formatMonthNumber } from "utils/dateFormatters";
import moment from "moment";

const PayWithQuickbucksConfirmationModal = (props: any) => {
  const { loadingApi, equityValue, tenor } = props;
  const { Option } = Select;
  const location = useLocation();
  const [status] = useState("Pending");
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [hideEquity, setHideEquity] = useState(true);

  const searchParams = new URLSearchParams(location.search);
  const paymentCode = searchParams.get("paymentCode");

  const dispatch = useAppDispatch();

  const paymentData = useAppSelector(
    (state) => state?.payLaterVendor?.paymentInfo
  );

  const [isChecked, setIsChecked] = useState(false);
  const [isNew] = useState(!paymentData?.Meta?.Items?.IsNew);

  const VehicleSchema = Yup.object().shape({
    EquityContribution: Yup.string().required(
      "Equity Contribution is Required"
    ),
    Tenor: Yup.string().required("Tenor is required"),
  });

  useEffect(() => {
    setIsChecked(paymentData?.Meta?.Items?.IsNew);
  }, []);

  function validateEquity(value: any) {
    const check = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/.test(value);

    let error;
    if (value > paymentData?.LoanAmount) {
      setHideEquity(true);
      error = "Amount must not exceed  loan amount!";
    }
    if (value < paymentData?.MinimumEquity) {
      setHideEquity(true);
      error = "input an amount equal to or above the minimum equity amount!";
    }
    if (check) {
      setHideEquity(true);
      error = "Only numbers are allowed";
    } else {
      setHideEquity(false);
    }

    return error;
  }

  function formatCurrency(amount: number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NGN",
    }).format(amount);
  }

  // const formattedAmount = formatCurrency(amount);

  const handleKeyDown = (event: any) => {
    const invalidChars = ["-", "e", "+", "E"];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div>
      <Modal
        title="Basic Modal"
        destroyOnClose={true}
        width={500}
        centered
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
        <div
          className={Styles.modalContentVerification}
          style={{ paddingTop: "0em" }}
        >
          {/* <div className={Styles.topHeader}>
            <div>
              <img
                onClick={props.handleBack}
                src={Back}
                className={Styles.backIcon}
                alt="back"
              />
            </div>
          </div>
          */}
          {loading ? (
            <LoadingCard />
          ) : (
            <div>
              <div
                className={Styles.modalContentVerification}
                style={{
                  paddingBottom: "0em",
                  paddingLeft: "0em",
                  paddingRight: "0em",
                }}
              >
                <div style={{ cursor: "pointer" }}>
                  <img
                    onClick={props.handleBack}
                    src={Back}
                    className={Styles.backIcon}
                    alt="back"
                  />
                </div>
                <div
                  style={{ textAlign: "center", paddingTop: "0em" }}
                  className={Styles.title}
                >
                  Paylater Loan Summary
                </div>
                <div
                  className={Styles.merchantBox}
                  style={{
                    background: "white",
                    height: "70vh",
                    overflow: "scroll",
                  }}
                >
                  <div className={Styles.merchantBox}>
                    {paymentData?.Meta?.Items ? (
                      <>
                        <div className={Styles.box}>
                          <div className={Styles.items}>
                            <span>No.</span>
                            <span>Item(s)</span>
                            <span>Quantity</span>
                            <span>Price</span>
                          </div>
                          {paymentData?.Meta?.Items.map(
                            (item: any, index: any) => (
                              <div className={Styles.item} key={index}>
                                {" "}
                                <span>{index + 1}</span>
                                <span>{item.Name}</span>
                                <span>{item.Quantity}</span>
                                <span>{formatAmount(item.Amount)}</span>
                              </div>
                            )
                          )}

                          <div className={Styles.item}>
                            <span></span>
                            <span></span>
                            <span
                              style={{ fontWeight: "700", fontSize: "14px" }}
                            >
                              Total
                            </span>
                            <span
                              style={{ fontWeight: "700", fontSize: "14px" }}
                            >
                              {formatAmount(paymentData?.Amount)}
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <span>No items found</span>
                    )}
                  </div>

                  {/* <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Car Inspection location
                  </div>
                  <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                    {paymentData?.Meta?.CarDetails?.LocationAddress}
                  </div>
                </div> */}

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Vendor Name</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {paymentData?.MerchantName}
                    </div>
                  </div>

                  {/* <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Contact Phone Number
                  </div>
                  <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                    {paymentData?.Meta?.CarDetails?.ContactNumber}
                  </div>
                </div> */}

                  {/* <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Car Value</div>
                  <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                    {formatAmount(paymentData?.Amount)}
                  </div>
                </div> */}

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Request Date</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {moment(paymentData?.CreatedOn).format("Do-MMM-YYYY")}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Expiry Date</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {moment(paymentData?.ExpiredOn).format("Do-MMM-YYYY")}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Loan Amount</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {formatAmount(paymentData?.LoanAmount)}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Monthly Repayment</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {formatAmount(paymentData?.MonthlyRepayment)}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Tenor</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {tenor || paymentData?.Tenor} Month(s)
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>
                      Equity Contribution Entered
                    </div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {formatAmount(
                        equityValue || paymentData?.EquityContribution
                      )}
                    </div>
                  </div>

                  {/* <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Comprehensive Motor Vehicle Insurance
                  </div>
                  <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                    {formatAmount(paymentData.VehicleInsurance)}
                  </div>
                </div> */}

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>
                      Credit Life Insurance
                    </div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {formatAmount(paymentData?.CreditLifeInsurance)}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Management Fee</div>
                    <div className={Styles.merchantHalfRight} style={{paddingRight:'0.4em'}}>
                      {formatAmount(paymentData?.ManagementFee)}
                    </div>
                  </div>
                  <div
                    className={Styles.borderLineTwo}
                    style={{ margin: "0em" }}
                  />
                  <div className={Styles.rowContent}>
                    <div
                      style={{ color: "#354764" }}
                      className={Styles.descTwo}
                    >
                      Total Upfront Charges
                    </div>
                    <div
                      style={{ fontWeight: "bolder", color: "#003883" }}
                      className={Styles.descTwo}
                    >
                      {formatAmount(paymentData?.TotalCharges)}
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  // paddingLeft: "2em",
                  // paddingRight: "2em",
                  paddingBottom: "1em",
                }}
              >
                <button onClick={props.openConfirmation} className={Styles.btn}>
                  PROCEED
                </button>
              </div>
            </div>
            // <div className={Styles.row}>
            //   <div className={Styles.half} style={{ marginTop: "0em" }}>
            //     <div className={Styles.userName}></div>
            //     <div className={Styles.subDetail}>
            //       Hello {paymentData?.Name}
            //     </div>
            //     <div className={Styles.subDetails}>Your order by Konga</div>
            //     <div className={Styles.merchantBox}>
            //       {paymentData?.Meta?.Items ? (
            //         <>
            //           <div className={Styles.box}>
            //             <div className={Styles.items}>
            //               <span>No.</span>
            //               <span>Item(s)</span>
            //               <span>Quantity</span>
            //               <span>Price</span>
            //             </div>
            //             {paymentData?.Meta?.Items.map(
            //               (item: any, index: any) => (
            //                 <div className={Styles.item} key={index}>
            //                   {" "}
            //                   <span>{index + 1}</span>
            //                   <span>{item.Name}</span>
            //                   <span>{item.Quantity}</span>
            //                   <span>{formatAmount(item.Amount)}</span>
            //                 </div>
            //               )
            //             )}

            //             <div className={Styles.item}>
            //               <span></span>
            //               <span></span>
            //               <span style={{ fontWeight: "700", fontSize: "14px" }}>
            //                 Total
            //               </span>
            //               <span style={{ fontWeight: "700", fontSize: "14px" }}>
            //               {formatAmount(paymentData?.Amount)}
            //               </span>
            //             </div>
            //           </div>
            //         </>
            //       ) : (
            //         <span>No items found</span>
            //       )}
            //       {/* })} */}
            //     </div>
            //   </div>

            //   <div className={Styles.halfTwo} style={{paddingTop:'0em'}}>
            //     <div className={Styles.loanBox} style={{ fontSize: "1.25rem",marginTop:'1rem'}}>
            //       Loan Summary
            //       <div className={Styles.loanBlueBoxs}>
            //         <div className={Styles.rowContent}>
            //           <div
            //             style={{ color: "#354764" }}
            //             className={Styles.descTwo}
            //           >
            //             Equity Contribution Entered
            //           </div>
            //           <div
            //             style={{ fontWeight: "bolder", color: "#003883" }}
            //             className={Styles.descTwo}
            //           >
            //             {formatAmount(props.equityValue)}
            //           </div>
            //         </div>
            //         <div className={Styles.rowContent}>
            //           <div
            //             style={{ color: "#354764" }}
            //             className={Styles.descTwo}
            //           >
            //             Credit Life Insurance
            //           </div>
            //           <div
            //             style={{ fontWeight: "bolder", color: "#003883" }}
            //             className={Styles.descTwo}
            //           >
            //             {formatAmount(paymentData?.CreditLifeInsurance)}
            //           </div>
            //         </div>
            //         <div className={Styles.rowContent}>
            //           <div
            //             style={{ color: "#354764" }}
            //             className={Styles.descTwo}
            //           >
            //             Management Fee
            //           </div>
            //           <div
            //             style={{ fontWeight: "bolder", color: "#003883" }}
            //             className={Styles.descTwo}
            //           >
            //             {formatAmount(paymentData?.ManagementFee)}
            //           </div>
            //         </div>
            //         <hr className={Styles.responsiveLine} />
            //         <div className={Styles.rowContent}>
            //           <div
            //             style={{ color: "#354764" }}
            //             className={Styles.descTwo}
            //           >
            //             Total Upfront Payment
            //           </div>
            //           <div
            //             style={{ fontWeight: "bolder", color: "#003883" }}
            //             className={Styles.descTwo}
            //           >
            //             {formatAmount(paymentData?.TotalCharges)}
            //           </div>
            //         </div>
            //       </div>
            //     </div>

            //     <Formik
            //       initialValues={{
            //         EquityContribution: "",
            //       }}
            //       validationSchema={VehicleSchema}
            //       onSubmit={props.openConfirmation}
            //     >
            //       {(formik) => (
            //         <Form>
            //           <div className={Styles.top}>
            //             <div className={""}>
            //               {/* Styles.rowSelect */}
            //               <div className={""}>
            //                 <div
            //                   style={{
            //                     fontSize: "12px !important",
            //                     color: "#5d6b82",
            //                     letterSpacing: "1px",
            //                     fontFamily: "Effra",
            //                   }}
            //                 >
            //                   <span
            //                     style={{ marginRight: "4px", color: "red" }}
            //                   >
            //                     *
            //                   </span>
            //                   Ensure your account is funded with the equity
            //                   contribution amount when booking loan
            //                   <button
            //                     onClick={() =>
            //                       window.open("your-link-here", "_blank")
            //                     }
            //                     style={{
            //                       background: "none",
            //                       border: "none",
            //                       color: "#228EF9",
            //                       textDecoration: "underline",
            //                       fontSize: "12px !important",
            //                       marginLeft: "4px",
            //                       cursor: "pointer",
            //                       padding: 0,
            //                     }}
            //                   >
            //                     Learn more
            //                   </button>
            //                 </div>
            //               </div>

            //               {!formik.errors.EquityContribution && !hideEquity && (
            //                 <div className={""}>
            //                   {/* Styles.inputHalfSelect */}
            //                   <div className={Styles.inputTitle}>
            //                     Please select a tenor
            //                     <span className={Styles.asteriks}>*</span>
            //                   </div>
            //                 </div>
            //               )}
            //             </div>
            //           </div>
            //           <div>
            //             <div>
            //               <div className={Styles.rowContents}>
            //                 <div className={Styles.descThrees}>Loan amount</div>
            //                 <div
            //                   style={{
            //                     fontWeight: "bolder",
            //                     color: "#003883",
            //                   }}
            //                   className={Styles.descThrees}
            //                 >
            //                   {formatAmount(paymentData?.LoanAmount)}
            //                 </div>
            //               </div>

            //               <div className={Styles.rowContents}>
            //                 <div className={Styles.descThrees}>
            //                   Monthly Repayment Amount
            //                 </div>
            //                 <div
            //                   style={{
            //                     fontWeight: "bolder",
            //                     color: "#003883",
            //                   }}
            //                   className={Styles.descThrees}
            //                 >
            //                   {formatAmount(
            //                     repaymentResponseData?.MonthlyRepayment
            //                   )}
            //                 </div>
            //               </div>
            //               <div className={Styles.rowContents}>
            //                 <div className={Styles.descThrees}>Tenor</div>
            //                 <div
            //                   style={{
            //                     fontWeight: "bolder",
            //                     color: "#003883",
            //                   }}
            //                   className={Styles.descThrees}
            //                 >
            //                   {formatMonthNumber(props.tenor)}
            //                 </div>
            //               </div>

            //               <div className={Styles.tops}>
            //                 <Button
            //                   variant="text-orange--border"
            //                   type="submit"
            //                   label="CANCEL"
            //                   style={{ width: "45%" }}
            //                   onClick={props.handleCancel}
            //                 />
            //                 <Button
            //                   variant="primary"
            //                   type="submit"
            //                   label="PROCEED"
            //                   style={{ width: "45%" }}
            //                   onClick={props.openConfirmation}
            //                 />
            //               </div>
            //             </div>
            //           </div>
            //         </Form>
            //       )}
            //     </Formik>
            //   </div>
            // </div>
          )}
        </div>
        <div></div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbucksConfirmationModal;
